<div class="container-fluid">
    <div class="p-md-3">
        <div class="row justify-content-center my-5 ">
            <div class="col-10 col-md-4 col-xl-3 my-2">
                <div class="h-100 m-3">
                    <div class="border rounded-1 background-light w-100 h-100 py-2 d-flex justify-content-center align-items-center">

                        <button appPreventDoubleClick class="m-auto" mat-fab color="primary" (throttledClick)="openSondeDialog();">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-10 col-md-4 col-xl-3 my-2" *ngFor="let s of SondeList; let i = index">
                <div class="h-100 m-3">
                    <!-- <div *ngIf="i === 0" class="border rounded-1 background-light w-100 h-100 p-3 clickable d-flex flex-column" [class.hatched]="!s.IsActive" (click)="openSondeDialog(s)">
                        <div class="row">
                            <h3 class=" text-center">{{s.Reference}} </h3>
                        </div>

                        <mat-chip-list class="d-flex justify-content-center ">
                            <mat-chip [style.background]="getBackgroundColorBySondeType(s.Type)"
                                      [style.color]="getTextColorBySondeType(s.Type)">{{getSondeTypeLabel(s.Type)}}</mat-chip>
                        </mat-chip-list>

                        <div class="row mt-3">
                            <span>{{s.FacteurCorrection}}</span>
                        </div>

                        <div class="row d-flex flex-row-reverse mt-auto g-0">
                            <button class="col-auto" appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary"
                                    (throttledClick)="deleteSonde(s)">
                                <mat-icon>{{s.IsActive ? 'check_box' : 'radio_button_unchecked'}}</mat-icon>
                            </button>
                        </div>
                         <div class="card-body">
                        <h5 class="card-title">{{s.Reference}}</h5>
                        <p class="card-text">{{getSondeTypeLabel(s.Type)}}</p>
                        <p class="card-text">{{s.FacteurCorrection}}</p>
                    </div> 
                    </div> -->
                    <div class="border rounded-1 background-light w-100 h-100 p-3 clickable d-flex flex-column" [class.hatched]="!s.IsActive" (click)="openSondeDialog(s)">
                        <div class="row">
                            <h3 class=" text-center">{{s.Reference}} </h3>
                        </div>

                        <mat-chip-list class="d-flex justify-content-center">
                            <mat-chip [style.background]="getBackgroundColorBySondeType(s.Type)"
                                      [style.color]="getTextColorBySondeType(s.Type)">{{getSondeTypeLabel(s.Type)}}</mat-chip>
                        </mat-chip-list>

                        <div class="row mt-3">
                            <span>{{s.FacteurCorrection}}</span>
                        </div>

                        <div class="row d-flex flex-row-reverse mt-auto g-0">

                            <button class="col-auto" [matTooltip]="s.IsActive ? 'désactiver' : 'activer'" appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary"
                                    (throttledClick)="deleteSonde(s)">
                                <mat-icon>{{s.IsActive ? 'check_box' : 'radio_button_unchecked'}}</mat-icon>
                            </button>

                            <button class="col-auto" matTooltip="Calibration" appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary"
                                    (throttledClick)="openCalibration(s)">
                                <mat-icon>tune</mat-icon>
                            </button>

                            <button class="col-auto" matTooltip="Historique" appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary"
                                    (throttledClick)="openHistory(s)">
                                <mat-icon>article</mat-icon>
                            </button>
                        </div>
                        <!-- <div class="card-body">
                        <h5 class="card-title">{{s.Reference}}</h5>
                        <p class="card-text">{{getSondeTypeLabel(s.Type)}}</p>
                        <p class="card-text">{{s.FacteurCorrection}}</p>
                    </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>